module.exports = __webpack_public_path__ + "img/Otp-guide-screen-3anim.7a4ed3b3.gif";